module.exports = __webpack_public_path__ + "img/MOTHERS DAY.9ca5dab.svg";